// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"267":"5ab2a189","488":"3aaac985","863":"c44ff26d"}[chunkId] + ".chunk.js";
};